module.exports = __webpack_public_path__ + "img/vue.6ac04dbb.png";